import { Summary } from './summary/summary'
import { TopTrends } from './top-trends'
import { InsightsTab, buildSummaryDetailsUrl } from './utils'
import { useInsightsData } from 'hooks/insights/useInsightsData'
import type { Insight } from './types'
import { Grid } from '@design-systems/canvas-ui'
import { useDwellTime, useLogClick } from 'utils/analytics'
import { StoreDistrictSnapshot } from './store-district-snapshot/store-district-snapshot'
import { CategoryPerformance } from './category-performance/category-performance'
import { FunFacts } from './fun-facts/fun-facts'
import { useNavigate, useLocation } from 'react-router-dom'
import { AudioPlayer } from './audio-player/audio-player'
import { useAudioData } from 'hooks/insights/useAudioData'

export const WeeklyTab = () => {
    useDwellTime('insights/weekly')
    const { logClick } = useLogClick('insights/weekly')
    const { data, renderGuard } = useInsightsData()
    const navigate = useNavigate()
    const locationFromRouter = useLocation()
    const { audio } = useAudioData()

    if (renderGuard) return renderGuard

    const weekly = data?.weekly_insights

    const storeSnapshot = weekly?.store_snapshot
    const insights = (weekly?.insights ?? []).filter(
        (i) => !!i.title && !!i.summary,
    ) as Insight[]

    return (
        <Grid.Container
            className="hc8-ph-4x hc8-pt-3x hc8-pb-4x insights-container"
            align="start"
            direction="column"
            spacing="expanded"
        >
            {audio.url && (
                <Grid.Item className="hc8-wth-100">
                    <AudioPlayer />
                </Grid.Item>
            )}
            <Grid.Item className="hc8-wth-100">
                <Summary
                    tab={InsightsTab.Weekly}
                    title={weekly?.summary?.title ?? null}
                    summary={weekly?.summary?.summary ?? null}
                    startDate={weekly?.week_starting_date}
                    endDate={weekly?.week_ending_date}
                    onClickSeeDetails={() => {
                        logClick('weekly summary see details')
                        void navigate(
                            buildSummaryDetailsUrl(
                                locationFromRouter.search,
                                InsightsTab.Weekly,
                            ),
                        )
                    }}
                />
            </Grid.Item>
            {storeSnapshot && (
                <Grid.Item className="hc8-wth-100">
                    <StoreDistrictSnapshot data={storeSnapshot} />
                </Grid.Item>
            )}
            {insights.length > 0 && (
                <Grid.Item className="hc8-wth-100">
                    <TopTrends insights={insights} />
                </Grid.Item>
            )}
            {weekly?.department_sales_comparisons && (
                <Grid.Item className="hc8-wth-100">
                    <CategoryPerformance
                        data={weekly.department_sales_comparisons}
                    />
                </Grid.Item>
            )}
            {weekly?.fun_facts?.length && (
                <Grid.Item className="hc8-wth-100">
                    <FunFacts data={weekly.fun_facts} />
                </Grid.Item>
            )}
        </Grid.Container>
    )
}
